import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { Lock, Unlock } from 'lucide-react'
import Button from '../ui/Button'

const TokenExpiredModal = ({ isOpen }) => {
  const navigate = useNavigate()
  const { setTokenExpired } = useAuth()

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [isOpen])

  // Prevent ESC key from closing modal
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) {
        e.preventDefault()
        e.stopPropagation()
      }
    }
    if (isOpen) {
      document.addEventListener('keydown', handleEscape)
    }
    return () => {
      document.removeEventListener('keydown', handleEscape)
    }
  }, [isOpen])

  const handleUnlock = (e) => {
    if (e) {
      e.preventDefault()
      e.stopPropagation()
    }
    // Reset token expired state
    setTokenExpired(false)
    // Use window.location for reliable navigation
    window.location.href = '/login'
  }

  if (!isOpen) return null

  return (
    <div 
      className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black bg-opacity-75"
      onClick={(e) => {
        // Prevent closing by clicking outside
        e.preventDefault()
        e.stopPropagation()
      }}
    >
      <div 
        className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 text-center"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex flex-col items-center mb-6">
          <div className="p-4 bg-red-100 rounded-full mb-4">
            <Lock className="text-red-600" size={48} />
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Dashboard Locked</h2>
          <p className="text-gray-600">
            Your session has expired. Please unlock to access the dashboard.
          </p>
        </div>
        
        <div className="space-y-4">
          <Button
            type="button"
            onClick={handleUnlock}
            className="w-full"
            size="lg"
          >
            <Unlock className="mr-2" size={20} />
            Unlock to Access
          </Button>
        </div>
      </div>
    </div>
  )
}

export default TokenExpiredModal

